<template>
  <div style="padding: 80px 0; text-align: center;">
    <h1>404</h1>
    <p>页面不存在</p>
    <el-button type="primary" @click="$router.push('/home')">返回首页</el-button>
  </div>
</template>

<script>
export default {}
</script>
